import { render, staticRenderFns } from "./exchangeOrder.vue?vue&type=template&id=68ea5cea&scoped=true"
import script from "./exchangeOrder.vue?vue&type=script&lang=ts"
export * from "./exchangeOrder.vue?vue&type=script&lang=ts"
import style0 from "./exchangeOrder.vue?vue&type=style&index=0&id=68ea5cea&prod&lang=scss"
import style1 from "./exchangeOrder.vue?vue&type=style&index=1&id=68ea5cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea5cea",
  null
  
)

export default component.exports